import './index.scss'

import React, { useEffect } from 'react'
import { useNavigate } from 'react-router'

import noFoundSrc from './404.png'
import Flex from './Flex'
import Text from './Text'

const NotFound = () => {
  const navigate = useNavigate()

  useEffect(() => {
    setTimeout(() => {
      navigate(`/${window.location.search}`)
    }, 1000)
  }, [])

  return (
    <Flex
      textAlign='center'
      justify='center'
      colGap={32}
      paddingTop={200}
      paddingBottom={200}
    >
      <img src={noFoundSrc} style={{ width: 256 }} />
      <Flex direction='column' rowGap={12} span='auto'>
        <p>
          <Text size={32} lineHeight={38} block>
            Oops! 
          </Text>
          <Text size={16} lineHeight={36}>
            Sorry, this page is invalid.
          </Text>
        </p>
        <Text
          className='ind-not-found'
          block
          cursor
          size={14}
          style={{ border: '1px solid #222222', padding: '5px 28px' }}
          onClick={() => {
            navigate('/')
          }}
        >
          Go Back
        </Text>
      </Flex>
    </Flex>
  )
}

export default NotFound
